import { useRouter } from "next/router";
import Gridcom from "../../src/components/Gridcom";
import FooterCom from "../../src/components/FooterCom";
import FooterDis from "../../src/Description/FooterDis";
import Headcom from "../../src/components/Headcom";
import Ad_728x90_Bot from "../../src/ads/Ad_728x90_Bot";
import GameCommonDis from "../../src/Description/GameCommonDis";
import CatDis from "../../src/Description/CatDis";
import { Assets } from "../../src/list/Assets";
import BlackScreen from "../../src/components/BlackScreen";
import Searchcom from "../../src/components/Searchcom";
import CookieCom from "../../src/components/CookieCom";
import CatBtn from "../../src/components/CatBtn";
import Snow_fx from "../../src/fx/Snow_fx";
import TagBtn from "../../src/components/TagBtn";
import { supabase } from "../../lib/supabaseClient";

export async function getStaticProps() {
  const { data: categories } = await supabase.from('categories').select('*');
  const { data: pages } = await supabase
    .from('pages')
    .select('*')
    .eq('name', 'All Categories')
    .single();

  return {
    props: {
      categories: categories || [],
      pageData: pages || null
    },
    revalidate: 60,
  };
}

export default function AllCategories({ categories, pageData }) {
  var keyWord;
  var Page_name;
  const path = useRouter();
  const pathName = path.query.id;

  return (
    <>
      <Headcom
        title={pageData?.title || 'All Categories'}
        s_dis={pageData?.s_dis || ''}
        path={pageData?.path ? pageData.path[1] + pageData.path[0] : ''}
        thumb={pageData?.thumb || ''}
        logo_16={Assets[0].logo_16}
        logo_32={Assets[0].logo_32}
        logo_192={Assets[0].logo_192}
        logo_270={Assets[0].logo_270}
        logo_512={Assets[0].logo_512}
      />
      <div className="app_cont_game">
        <div className="game-root tags_roots">
          <div className="container">
            {/* <Logocom /> */}
          </div>
          {/* <div className="tags_heading"></div> */}
        </div>
        <div className="all_tags_container">
          <div className="cat_heading">
            {pageData?.dis ? (
              <div dangerouslySetInnerHTML={{ __html: pageData.dis }} />
            ) : (
              <h1>All Categories</h1>
            )}
          </div>
          <CatBtn />
         
        </div>
       
        <div className="cat_heading">
            <h2>All Tags</h2>
          </div>
          
          <TagBtn categories={categories} />
        <Ad_728x90_Bot />
        <GameCommonDis />
        <CookieCom />
      </div>
      {/* <FooterDis /> */}
      <FooterCom />
      <Snow_fx />
    </>
  );
}
